<template>
    <div class="jump-cart">
        <van-nav-bar title="绑定账户" left-arrow fixed class="jump-nav-bar" @click-left="back">
            <div slot="right" class="jump-nav-bar-rhd">
                <span @click="showAdd">新增</span>
            </div>
        </van-nav-bar>
        <div class="jump-cart-body">
            <!-- <div class="jump-cart-body-hd"></div>-->

            <van-swipe-cell :right-width="65" class="jump-cart-item-hd" v-for="(item,i) in list">
                <van-row class="jump-cart-item" type="flex">
                    <van-col span="10" class="jump-cart-item-img">
                        {{item.userName}}
                    </van-col>
                    <van-col span="14" class="jump-cart-item-warp">
                        <p class="item-price" style="text-align: left">
                            <van-button size="small" type="info" v-if="item.id==checkedId">使用中</van-button>
                            <van-button size="small" type="info" v-else @click="placeOrderByBindAccount(item.id)">去下单</van-button>

                            <van-button size="small" type="warning" style="margin-left: 10px" @click="bindAccountDel(item.id)">解除绑定</van-button>
                        </p>

                    </van-col>
                </van-row>
            </van-swipe-cell>
            <van-dialog
                    v-model="show"
                    title="绑定账户"
                    show-cancel-button
                    @confirm="bindAccountSave"
            >
                <van-cell-group>
                    <van-field v-model="name" placeholder="请输入用户名" />
                    <van-field v-model="pwd" placeholder="请输入密码" />
                </van-cell-group>
            </van-dialog>

        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, SwipeCell, List, Button,Dialog,Field } from "vant";

    export default {
        name: "usercollect",
        components: {
            [Field.name]: Field,
            [Dialog.name]: Dialog,
            [Button.name]: Button,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [SwipeCell.name]: SwipeCell,
            [List.name]: List
        },
        data() {
            return {
                list: [],
                checkedId:'',
                show: false,
                name:'',
                pwd:''
            };
        },
        methods: {
            showAdd(){
                this.name=''
                this.pwd=''
                this.show=true
            },
            back() {
                history.back();
            },  bindAccountSave() {
                let that = this;
                this.$api.get(that.jumuc.userCenter.bindAccountSave, {'userName': that.name,'password': that.pwd},
                    successRes => {
                        that.$toast(successRes.msg)
                        if (successRes.success) {
                            that.bindAccountList();
                        }
                    })

            },
            bindAccountDel(id) {
                let that = this;
                this.$api.get(that.jumuc.userCenter.bindAccountDel, {'userId': id},
                    successRes => {
                        that.$toast(successRes.msg)
                        if (successRes.success) {
                            that.bindAccountList();
                        }
                    })

            },
            placeOrderByBindAccount(id) {
                let that = this;
                this.$api.get(that.jumuc.userCenter.placeOrderByBindAccount, {'userId': id},
                    successRes => {
                        that.$toast(successRes.msg)
                        if (successRes.success) {
                            that.bindAccountList();
                        }
                    })
            },
            bindAccountList() {
                let that = this;
                this.$api.get(that.jumuc.userCenter.bindAccountList, null,
                    successRes => {
                        that.list=[]
                        that.list = successRes.data.users
                        that.checkedId=successRes.data.checkedId
                    })
            }
        },
        mounted() {
            this.bindAccountList()
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-nav-bar-rhd {
        color: #fff;
        font-size: 16px;
        i {
            font-size: 18px;
        }
        span {
            margin-left: 10px;
        }
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            align-items: center;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
                color: #666;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }

        &-filter {
            padding: 10px;
            color: #fff;
            position: relative;
            &-item {
                font-size: 14px;
                i {
                    vertical-align: -2px;
                    padding-left: 3px;
                }
            }
        }
        .jump-cart-item-hd {

            border-radius: 20px;
            background-color: #fff;
            margin-bottom: 15px;
            .van-swipe-cell__right {
                background-color: #f00;
                color: #fff;
                width: 65px;
                text-align: center;
                span {
                    display: inline-block;
                    margin-top: 100%;
                }
            }
        }
    }
</style>

